import { ReactElement } from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON } from '@utils/const';
import { useSelector } from 'react-redux';

const CardProductTileSkeleton = () : ReactElement => {

    const isMobile = useSelector(state => state.cart.isMobile);

    const height = isMobile ? '526px' : '226px';

    return (
        <ContentLoader
            speed={SKELETON.speed}
            backgroundColor={SKELETON.backgroundColor}
            width="100%" 
            height={height}
        >
            <rect x="0" y="0" rx="5" ry="5" width="100%" height={height} />
        </ContentLoader>
    )
}

export default CardProductTileSkeleton;